export interface Chapter {
  id: number;
  title: string;
  date: string;
}

export interface Comic {
  id: number;
  title: string;
  cover: string;
  category: string;
  author: string;
  status: '连载中' | '已完结';
  rating: number;
  views: string;
  likes: number;
  tags: string[];
  description: string;
  featured?: boolean;
  hot?: boolean;
  lastUpdate: string;
  chapters: Chapter[];
}

export interface Category {
  id: string;
  name: string;
  icon: string;
  description: string;
  count: number;
}

export const categories: Category[] = [
  { id: 're', name: '热血', icon: 'ri-fire-fill', description: '热血激昂,点燃你的斗志', count: 128 },
  { id: 'lian', name: '恋爱', icon: 'ri-heart-3-fill', description: '甜蜜心动,治愈系恋爱故事', count: 96 },
  { id: 'xuan', name: '悬疑', icon: 'ri-eye-fill', description: '烧脑推理,层层反转的谜团', count: 74 },
  { id: 'qi', name: '奇幻', icon: 'ri-sparkling-2-fill', description: '想象无界,剑与魔法的世界', count: 112 },
  { id: 'ke', name: '科幻', icon: 'ri-rocket-2-fill', description: '未来世界,星际与机械的碰撞', count: 58 },
  { id: 'gao', name: '搞笑', icon: 'ri-emotion-laugh-fill', description: '轻松欢乐,笑到停不下来', count: 66 },
  { id: 'mao', name: '冒险', icon: 'ri-compass-3-fill', description: '勇往直前,探索未知秘境', count: 83 },
  { id: 'xiao', name: '校园', icon: 'ri-graduation-cap-fill', description: '青春校园,纯真而美好的时光', count: 71 },
];

export const comics: Comic[] = [
  {
    id: 1,
    title: '燃魂少年',
    cover: 'https://readdy.ai/api/search-image?query=A%20fiery%20young%20hero%20boy%20with%20flame%20energy%20surrounding%20him%2C%20vibrant%20comic%20book%20cover%20illustration%2C%20bold%20outlines%2C%20warm%20coral%20and%20orange%20palette%2C%20clean%20minimal%20beige%20background%2C%20dynamic%20action%20pose%2C%20professional%20manga%20cover%20art%2C%20high%20detail%2C%20cohesive%20warm%20color%20scheme&width=480&height=640&seq=comic-ranhun&orientation=portrait',
    category: 're',
    author: '林一燃',
    status: '连载中',
    rating: 9.2,
    views: '1.2亿',
    likes: 458200,
    tags: ['热血', '战斗', '成长'],
    description: '少年陈燃天生拥有失控的火焰能力,在一次次战斗中学会掌控自己的力量,守护身边最重要的人。这是关于勇气、羁绊与成长的燃系少年故事。',
    featured: true,
    hot: true,
    lastUpdate: '3小时前',
    chapters: [
      { id: 101, title: '第1话 觉醒的火焰', date: '2026-08-16' },
      { id: 102, title: '第2话 失控的力量', date: '2026-08-14' },
      { id: 103, title: '第3话 初次对战', date: '2026-08-12' },
      { id: 104, title: '第4话 并肩的伙伴', date: '2026-08-09' },
      { id: 105, title: '第5话 火焰之心', date: '2026-08-06' },
      { id: 106, title: '第6话 宿命的敌人', date: '2026-08-02' },
      { id: 107, title: '第7话 燃尽之夜', date: '2026-07-29' },
      { id: 108, title: '第8话 新的征程', date: '2026-07-25' },
    ],
  },
  {
    id: 2,
    title: '武道巅峰',
    cover: 'https://readdy.ai/api/search-image?query=Muscular%20martial%20artist%20in%20traditional%20Chinese%20tunic%20striking%20a%20powerful%20fist%20pose%2C%20vibrant%20comic%20book%20cover%20illustration%2C%20bold%20ink%20outlines%2C%20warm%20coral%20and%20dark%20ink%20palette%2C%20clean%20minimal%20beige%20background%2C%20dynamic%20manga%20cover%20art%2C%20high%20detail%2C%20cohesive%20warm%20color%20scheme&width=480&height=640&seq=comic-wudao&orientation=portrait',
    category: 're',
    author: '墨山河',
    status: '连载中',
    rating: 9.0,
    views: '9600万',
    likes: 382100,
    tags: ['热血', '武侠', '修炼'],
    description: '出身平凡的少年林远,意外获得上古武学传承,从此踏上以武问道的巅峰之路。宗门纷争、江湖恩怨,一段荡气回肠的武道传奇就此展开。',
    hot: true,
    lastUpdate: '5小时前',
    chapters: [
      { id: 201, title: '第1话 平凡少年', date: '2026-08-16' },
      { id: 202, title: '第2话 上古传承', date: '2026-08-13' },
      { id: 203, title: '第3话 初入江湖', date: '2026-08-10' },
      { id: 204, title: '第4话 宗门大比', date: '2026-08-07' },
      { id: 205, title: '第5话 以一敌三', date: '2026-08-03' },
    ],
  },
  {
    id: 3,
    title: '星海骑士',
    cover: 'https://readdy.ai/api/search-image?query=Gallant%20knight%20in%20shining%20armor%20holding%20a%20glowing%20sword%20under%20a%20starry%20cosmic%20sky%2C%20vibrant%20comic%20book%20cover%20illustration%2C%20bold%20outlines%2C%20deep%20teal%20and%20gold%20palette%20with%20warm%20stars%2C%20clean%20minimal%20background%2C%20epic%20fantasy%20manga%20cover%20art%2C%20high%20detail%2C%20cohesive%20color%20scheme&width=480&height=640&seq=comic-xinghai&orientation=portrait',
    category: 'qi',
    author: '白夜行',
    status: '连载中',
    rating: 9.1,
    views: '8200万',
    likes: 310500,
    tags: ['奇幻', '史诗', '星战'],
    description: '在一座漂浮于星海的古老王国,年轻的见习骑士伊莱为追寻失踪的父亲,踏上了穿越星系与魔法大陆的旅程。星海尽头,藏着王国兴衰的秘密。',
    featured: true,
    lastUpdate: '昨天',
    chapters: [
      { id: 301, title: '第1话 见习骑士', date: '2026-08-15' },
      { id: 302, title: '第2话 星海的召唤', date: '2026-08-12' },
      { id: 303, title: '第3话 遗落的剑', date: '2026-08-09' },
      { id: 304, title: '第4话 魔法导师', date: '2026-08-05' },
      { id: 305, title: '第5话 跨界之门', date: '2026-07-30' },
    ],
  },
  {
    id: 4,
    title: '龙之纪元',
    cover: 'https://readdy.ai/api/search-image?query=Majestic%20dragon%20soaring%20above%20ancient%20ruins%20with%20warm%20golden%20light%2C%20vibrant%20comic%20book%20cover%20illustration%2C%20bold%20outlines%2C%20amber%20gold%20and%20coral%20palette%2C%20clean%20minimal%20warm%20background%2C%20epic%20fantasy%20manga%20cover%20art%2C%20high%20detail%2C%20cohesive%20warm%20color%20scheme&width=480&height=640&seq=comic-longzhi&orientation=portrait',
    category: 'qi',
    author: '龙须糖',
    status: '已完结',
    rating: 9.4,
    views: '1.5亿',
    likes: 520400,
    tags: ['奇幻', '龙族', '冒险'],
    description: '人类与龙族签订契约的时代,少女阿璃被选为新一代的驯龙师。当远古巨龙苏醒,和平的契约面临破碎,她必须与伙伴一起守护这个龙与人共存的世界。',
    lastUpdate: '1周前',
    chapters: [
      { id: 401, title: '第1话 驯龙师之选', date: '2026-08-10' },
      { id: 402, title: '第2话 初遇小龙', date: '2026-08-06' },
      { id: 403, title: '第3话 契约之印', date: '2026-08-01' },
      { id: 404, title: '第4话 巨龙觉醒', date: '2026-07-27' },
      { id: 405, title: '第5话 终章 守护的誓言', date: '2026-07-22' },
    ],
  },
  {
    id: 5,
    title: '迷雾侦探',
    cover: 'https://readdy.ai/api/search-image?query=Mysterious%20detective%20in%20trench%20coat%20with%20magnifying%20glass%20standing%20in%20foggy%20noir%20city%20alley%2C%20vibrant%20comic%20book%20cover%20illustration%2C%20bold%20outlines%2C%20teal%20grey%20and%20amber%20moody%20palette%2C%20clean%20minimal%20background%2C%20suspenseful%20manga%20cover%20art%2C%20high%20detail%2C%20cohesive%20color%20scheme&width=480&height=640&seq=comic-miwu&orientation=portrait',
    category: 'xuan',
    author: '雾里看花',
    status: '连载中',
    rating: 9.3,
    views: '7300万',
    likes: 296800,
    tags: ['悬疑', '推理', '都市'],
    description: '雨夜的城市总是藏着秘密。私家侦探江澈接手一桩离奇的连环失踪案,每一条线索都指向十年前一场被掩盖的火灾。真相,就藏在迷雾深处。',
    featured: true,
    lastUpdate: '4小时前',
    chapters: [
      { id: 501, title: '第1话 雨夜来客', date: '2026-08-16' },
      { id: 502, title: '第2话 失踪的少女', date: '2026-08-13' },
      { id: 503, title: '第3话 十年前的火灾', date: '2026-08-10' },
      { id: 504, title: '第4话 迷雾之中', date: '2026-08-06' },
      { id: 505, title: '第5话 反转真相', date: '2026-08-02' },
    ],
  },
  {
    id: 6,
    title: '午夜图书馆',
    cover: 'https://readdy.ai/api/search-image?query=Old%20librarian%20surrounded%20by%20floating%20books%20in%20a%20moonlit%20library%20at%20midnight%2C%20vibrant%20comic%20book%20cover%20illustration%2C%20bold%20outlines%2C%20deep%20teal%20and%20warm%20amber%20lamp%20light%2C%20clean%20minimal%20dark%20background%2C%20mysterious%20manga%20cover%20art%2C%20high%20detail%2C%20cohesive%20color%20scheme&width=480&height=640&seq=comic-wuye&orientation=portrait',
    category: 'xuan',
    author: '夜猫子',
    status: '已完结',
    rating: 8.9,
    views: '5100万',
    likes: 198400,
    tags: ['悬疑', '奇幻', '惊悚'],
    description: '每晚午夜,图书馆里无人翻阅的书会自行翻动,写下新的结局。管理员小暮发现,书中的故事竟能改写现实。想要改变命运的人,都来这里借走一本书。',
    lastUpdate: '2周前',
    chapters: [
      { id: 601, title: '第1话 午夜的访客', date: '2026-08-01' },
      { id: 602, title: '第2话 会翻动的书', date: '2026-07-28' },
      { id: 603, title: '第3话 改写结局', date: '2026-07-23' },
      { id: 604, title: '第4话 禁忌的书页', date: '2026-07-18' },
      { id: 605, title: '第5话 终章 闭馆时分', date: '2026-07-13' },
    ],
  },
  {
    id: 7,
    title: '心动咖啡店',
    cover: 'https://readdy.ai/api/search-image?query=Cozy%20cafe%20scene%20with%20a%20smiling%20barista%20girl%20holding%20a%20latte%2C%20warm%20pastel%20lighting%2C%20vibrant%20comic%20book%20cover%20illustration%2C%20bold%20soft%20outlines%2C%20coral%20pink%20and%20cream%20palette%2C%20clean%20minimal%20background%2C%20sweet%20romance%20manga%20cover%20art%2C%20high%20detail%2C%20cohesive%20warm%20color%20scheme&width=480&height=640&seq=comic-xindong&orientation=portrait',
    category: 'lian',
    author: '糖心小筑',
    status: '连载中',
    rating: 9.0,
    views: '6800万',
    likes: 305200,
    tags: ['恋爱', '治愈', '日常'],
    description: '街角新开了一家咖啡店,沉默寡言的咖啡师遇到爱笑的常客女孩。一杯拉花咖啡,两颗慢慢靠近的心,甜度刚刚好的都市恋爱物语。',
    featured: true,
    lastUpdate: '6小时前',
    chapters: [
      { id: 701, title: '第1话 街角的咖啡香', date: '2026-08-16' },
      { id: 702, title: '第2话 第一杯特调', date: '2026-08-13' },
      { id: 703, title: '第3话 雨天的约定', date: '2026-08-09' },
      { id: 704, title: '第4话 心跳的拉花', date: '2026-08-05' },
      { id: 705, title: '第5话 告白进行时', date: '2026-08-01' },
    ],
  },
  {
    id: 8,
    title: '春日迟迟',
    cover: 'https://readdy.ai/api/search-image?query=Two%20school%20students%20walking%20under%20cherry%20blossom%20trees%20in%20spring%2C%20soft%20warm%20pastel%20lighting%2C%20vibrant%20comic%20book%20cover%20illustration%2C%20bold%20soft%20outlines%2C%20pink%20and%20cream%20palette%2C%20clean%20minimal%20background%2C%20sweet%20romance%20manga%20cover%20art%2C%20high%20detail%2C%20cohesive%20color%20scheme&width=480&height=640&seq=comic-chunri&orientation=portrait',
    category: 'lian',
    author: '晚风拂柳',
    status: '连载中',
    rating: 8.8,
    views: '4500万',
    likes: 176500,
    tags: ['恋爱', '校园', '青春'],
    description: '樱花飘落的春天,转学生顾迟迟遇见了温柔的学长。一封没写完的情书,一场迟到了三年的告白,青涩而美好。',
    lastUpdate: '3天前',
    chapters: [
      { id: 801, title: '第1话 樱花转学生', date: '2026-08-13' },
      { id: 802, title: '第2话 学长与画板', date: '2026-08-09' },
      { id: 803, title: '第3话 未写完的情书', date: '2026-08-04' },
      { id: 804, title: '第4话 迟到的春天', date: '2026-07-30' },
    ],
  },
  {
    id: 9,
    title: '星际漫游者',
    cover: 'https://readdy.ai/api/search-image?query=Explorer%20in%20space%20suit%20floating%20near%20a%20colorful%20nebula%20with%20a%20small%20spaceship%2C%20vibrant%20comic%20book%20cover%20illustration%2C%20bold%20outlines%2C%20deep%20teal%20and%20warm%20orange%20nebula%20palette%2C%20clean%20minimal%20space%20background%2C%20sci-fi%20manga%20cover%20art%2C%20high%20detail%2C%20cohesive%20color%20scheme&width=480&height=640&seq=comic-xingji&orientation=portrait',
    category: 'ke',
    author: '银河旅人',
    status: '连载中',
    rating: 9.1,
    views: '5900万',
    likes: 241000,
    tags: ['科幻', '星际', '冒险'],
    description: '地球纪元2387年,人类开始向外星系殖民。年轻的星际货运员诺亚在一次次跃迁中,发现了关于宇宙起源的惊天秘密。',
    featured: true,
    lastUpdate: '2小时前',
    chapters: [
      { id: 901, title: '第1话 跃迁之日', date: '2026-08-16' },
      { id: 902, title: '第2话 货运员诺亚', date: '2026-08-12' },
      { id: 903, title: '第3话 外星信号', date: '2026-08-08' },
      { id: 904, title: '第4话 失落殖民地', date: '2026-08-03' },
      { id: 905, title: '第5话 宇宙起源', date: '2026-07-29' },
    ],
  },
  {
    id: 10,
    title: '机械纪元',
    cover: 'https://readdy.ai/api/search-image?query=Young%20pilot%20standing%20in%20front%20of%20a%20giant%20humanoid%20mecha%20robot%2C%20vibrant%20comic%20book%20cover%20illustration%2C%20bold%20outlines%2C%20metallic%20grey%20with%20warm%20orange%20accents%2C%20clean%20minimal%20industrial%20background%2C%20sci-fi%20mecha%20manga%20cover%20art%2C%20high%20detail%2C%20cohesive%20color%20scheme&width=480&height=640&seq=comic-jixie&orientation=portrait',
    category: 'ke',
    author: '齿轮之心',
    status: '连载中',
    rating: 8.9,
    views: '4700万',
    likes: 189300,
    tags: ['科幻', '机战', '热血'],
    description: '世界被巨型机械AI统治,人类最后的抵抗军驾驶着名为「钢铁之心」的机甲,为了自由与尊严展开最后的反击。',
    lastUpdate: '4天前',
    chapters: [
      { id: 1001, title: '第1话 钢铁之心', date: '2026-08-12' },
      { id: 1002, title: '第2话 觉醒的驾驶员', date: '2026-08-08' },
      { id: 1003, title: '第3话 抵抗军集结', date: '2026-08-03' },
      { id: 1004, title: '第4话 钢铁决战', date: '2026-07-29' },
    ],
  },
  {
    id: 11,
    title: '上班族日常',
    cover: 'https://readdy.ai/api/search-image?query=Humorous%20office%20worker%20character%20with%20laptop%20and%20coffee%2C%20comic%20chibi%20style%2C%20vibrant%20comic%20book%20cover%20illustration%2C%20bold%20outlines%2C%20warm%20cream%20and%20coral%20palette%2C%20clean%20minimal%20office%20background%2C%20funny%20slice%20of%20life%20manga%20cover%20art%2C%20high%20detail%2C%20cohesive%20color%20scheme&width=480&height=640&seq=comic-shangban&orientation=portrait',
    category: 'gao',
    author: '摸鱼大师',
    status: '连载中',
    rating: 9.0,
    views: '8800万',
    likes: 412600,
    tags: ['搞笑', '日常', '职场'],
    description: '周一综合征、加班魔咒、老板的夺命连环call……社畜小白的日常永远鸡飞狗跳。爆笑解压的职场日常,总有一个瞬间让你笑着笑着就哭了。',
    hot: true,
    lastUpdate: '1小时前',
    chapters: [
      { id: 1101, title: '第1话 周一的诅咒', date: '2026-08-16' },
      { id: 1102, title: '第2话 加班之夜', date: '2026-08-14' },
      { id: 1103, title: '第3话 摸鱼艺术', date: '2026-08-11' },
      { id: 1104, title: '第4话 老板的夺命call', date: '2026-08-07' },
      { id: 1105, title: '第5话 甲方爸爸', date: '2026-08-03' },
    ],
  },
  {
    id: 12,
    title: '秘境探险家',
    cover: 'https://readdy.ai/api/search-image?query=Bold%20explorer%20with%20backpack%20and%20map%20standing%20before%20a%20mysterious%20jungle%20temple%2C%20vibrant%20comic%20book%20cover%20illustration%2C%20bold%20outlines%2C%20warm%20green%20and%20gold%20palette%2C%20clean%20minimal%20jungle%20background%2C%20adventure%20manga%20cover%20art%2C%20high%20detail%2C%20cohesive%20color%20scheme&width=480&height=640&seq=comic-mijing&orientation=portrait',
    category: 'mao',
    author: '地图上的猫',
    status: '连载中',
    rating: 8.8,
    views: '3900万',
    likes: 148700,
    tags: ['冒险', '解密', '丛林'],
    description: '传说中的「失落之城」就在那片无人敢踏足的丛林深处。为了完成爷爷的遗愿,年轻的探险家阿凯带着一张残破的地图,踏上了凶险的寻宝之旅。',
    lastUpdate: '5天前',
    chapters: [
      { id: 1201, title: '第1话 残破的地图', date: '2026-08-11' },
      { id: 1202, title: '第2话 闯入丛林', date: '2026-08-06' },
      { id: 1203, title: '第3话 失落的石碑', date: '2026-08-01' },
      { id: 1204, title: '第4话 迷雾古城', date: '2026-07-27' },
    ],
  },
  {
    id: 13,
    title: '深海猎人',
    cover: 'https://readdy.ai/api/search-image?query=Diver%20swimming%20beside%20a%20giant%20leviathan%20sea%20creature%20in%20deep%20blue%20ocean%2C%20vibrant%20comic%20book%20cover%20illustration%2C%20bold%20outlines%2C%20deep%20teal%20with%20warm%20gold%20light%20rays%2C%20clean%20minimal%20underwater%20background%2C%20adventure%20manga%20cover%20art%2C%20high%20detail%2C%20cohesive%20color%20scheme&width=480&height=640&seq=comic-shenhai&orientation=portrait',
    category: 'mao',
    author: '蓝鲸尾',
    status: '已完结',
    rating: 8.7,
    views: '3200万',
    likes: 127400,
    tags: ['冒险', '海洋', '奇幻'],
    description: '海平面以下两千米,是另一个世界。深海猎人们驾驶潜艇,追猎传说中的巨型海兽。每一次下潜,都是与未知的较量。',
    lastUpdate: '1个月前',
    chapters: [
      { id: 1301, title: '第1话 下潜', date: '2026-07-20' },
      { id: 1302, title: '第2话 海沟深处', date: '2026-07-15' },
      { id: 1303, title: '第3话 利维坦', date: '2026-07-10' },
      { id: 1304, title: '第4话 终章 浮出水面', date: '2026-07-05' },
    ],
  },
  {
    id: 14,
    title: '校园篮球队',
    cover: 'https://readdy.ai/api/search-image?query=Energetic%20teenage%20basketball%20players%20in%20action%20on%20a%20court%2C%20vibrant%20comic%20book%20cover%20illustration%2C%20bold%20outlines%2C%20warm%20orange%20and%20cream%20palette%2C%20clean%20minimal%20gymnasium%20background%2C%20sports%20manga%20cover%20art%2C%20high%20detail%2C%20cohesive%20color%20scheme&width=480&height=640&seq=comic-lanqiu&orientation=portrait',
    category: 'xiao',
    author: '篮板王',
    status: '连载中',
    rating: 8.9,
    views: '4200万',
    likes: 163900,
    tags: ['校园', '运动', '热血'],
    description: '从倒数第一到全国大赛,一支不被看好的校园篮球队,用汗水与热血书写逆袭传奇。灌篮的瞬间,青春在燃烧。',
    hot: true,
    lastUpdate: '2天前',
    chapters: [
      { id: 1401, title: '第1话 倒数第一', date: '2026-08-14' },
      { id: 1402, title: '第2话 新来的王牌', date: '2026-08-10' },
      { id: 1403, title: '第3话 第一次合练', date: '2026-08-05' },
      { id: 1404, title: '第4话 县大赛开赛', date: '2026-07-31' },
    ],
  },
  {
    id: 15,
    title: '青涩时光',
    cover: 'https://readdy.ai/api/search-image?query=Group%20of%20high%20school%20students%20in%20uniform%20on%20a%20sunny%20school%20rooftop%2C%20warm%20soft%20afternoon%20light%2C%20vibrant%20comic%20book%20cover%20illustration%2C%20bold%20soft%20outlines%2C%20cream%20and%20warm%20yellow%20palette%2C%20clean%20minimal%20background%2C%20youthful%20manga%20cover%20art%2C%20high%20detail%2C%20cohesive%20color%20scheme&width=480&height=640&seq=comic-qingse&orientation=portrait',
    category: 'xiao',
    author: '夏日的蝉',
    status: '连载中',
    rating: 8.8,
    views: '3600万',
    likes: 139200,
    tags: ['校园', '青春', '日常'],
    description: '那些年一起度过的午后,写满心事的课本,偷偷交换的纸条……用最温柔的方式,记录每个人最美好的青涩时光。',
    lastUpdate: '1周前',
    chapters: [
      { id: 1501, title: '第1话 开学第一天', date: '2026-08-09' },
      { id: 1502, title: '第2话 交换的纸条', date: '2026-08-04' },
      { id: 1503, title: '第3话 天台上的约定', date: '2026-07-30' },
      { id: 1504, title: '第4话 毕业的前奏', date: '2026-07-25' },
    ],
  },
  {
    id: 16,
    title: '吐槽大会',
    cover: 'https://readdy.ai/api/search-image?query=Comedic%20masked%20host%20with%20microphone%20and%20exaggerated%20funny%20expression%20on%20a%20stage%2C%20vibrant%20comic%20book%20cover%20illustration%2C%20bold%20outlines%2C%20warm%20coral%20and%20gold%20palette%2C%20clean%20minimal%20stage%20background%2C%20humorous%20manga%20cover%20art%2C%20high%20detail%2C%20cohesive%20color%20scheme&width=480&height=640&seq=comic-tucao&orientation=portrait',
    category: 'gao',
    author: '段子手老周',
    status: '已完结',
    rating: 8.6,
    views: '2800万',
    likes: 118600,
    tags: ['搞笑', '脱口秀', '日常'],
    description: '每周五晚,老周的吐槽大会准时开麦。从生活琐事到社会热点,一本正经地胡说八道,笑点密集到根本停不下来。',
    lastUpdate: '3周前',
    chapters: [
      { id: 1601, title: '第1话 开麦了', date: '2026-07-26' },
      { id: 1602, title: '第2话 生活百态', date: '2026-07-19' },
      { id: 1603, title: '第3话 热梗大乱斗', date: '2026-07-12' },
      { id: 1604, title: '第4话 终章 谢幕', date: '2026-07-05' },
    ],
  },
];

export function getCategoryById(id: string): Category | undefined {
  return categories.find((c) => c.id === id);
}

export function getCategoryName(id: string): string {
  return getCategoryById(id)?.name ?? '全部';
}

export function getComicById(id: number): Comic | undefined {
  return comics.find((c) => c.id === id);
}